import { Copy, Send } from "lucide-react";
import { toast } from "../ui/sonner";

export function SuggestedMessageSection({ section, onSendMessage, index }) {
  const handleCopy = async () => {
    await navigator.clipboard.writeText(section.content);
    toast.success("Mensaje copiado");
  };

  return (
    <div
      data-testid={`typed-section-suggested-message-${index}`}
      className="my-3 border-l-4 border-emerald-500 bg-emerald-500/5 rounded-r-lg px-4 py-3"
    >
      <p className="text-sm italic text-foreground">{section.content}</p>
      <div className="flex gap-3 mt-2">
        <button
          data-testid={`suggested-message-copy-${index}`}
          onClick={handleCopy}
          className="text-xs flex items-center gap-1 text-muted-foreground hover:text-foreground transition-colors"
        >
          <Copy className="h-3 w-3" /> Copiar
        </button>
        <button
          data-testid={`suggested-message-send-${index}`}
          onClick={() => onSendMessage(section.content)}
          className="text-xs flex items-center gap-1 text-emerald-500 hover:text-emerald-400 transition-colors"
        >
          <Send className="h-3 w-3" /> Enviar
        </button>
      </div>
    </div>
  );
}
